module.exports = __webpack_public_path__ + "img/packages/dragndrop.204339.png";